import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Layout from '../../components/global/layout';
import ApiClient from '../../methods/api/apiClient';
import loader from '../../methods/loader';
import { useSelector } from 'react-redux';
import methodModel from '../../methods/methods';
import rolesModel from '../../models/roles.model';
import moment from 'moment';

const Viewfaq = (p) => {
  const history = useNavigate();
  const user = useSelector((state) => state.user);
  const { id, userId } = useParams();
  const [data, setData] = useState();
  const [Permissions, setPermission] = useState({});
  const getDetail = (did) => {
    loader(true);
    ApiClient.get(`faq`, { id: did }).then((res) => {
      if (res.success) {
        setData(res.data);
      }
      loader(false);
    });
  };

  const back = () => {
    history(-1);
  };

  useEffect(() => {
    getDetail(userId ? userId : id);
  }, [id, userId]);

  return (
    <Layout>
      <div className="pprofile1 shadow-lg">
        <div className="flex items-center mb-8">
          <button
            type="button"
            class="!px-4 bg-[#fff] py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all mr-3"
            to="/faq"
            onClick={back}
          >
            <i class="fa fa-angle-left text-lg"></i>
          </button>
          <div>
            <h3 className="text-2xl font-semibold text-[#111827]">View Faq</h3>
            <p className="text-sm font-normal text-[#525252]">
              Here you can see all detail about Faq
            </p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Category</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data &&
                methodModel.capitalizeFirstLetter(data?.category_id?.name)}
            </div>
          </div>
        <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Status</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {(data &&
                methodModel.capitalizeFirstLetter(data?.status)) ||
                '--'}
            </div>
          </div>
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Question</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data && methodModel.capitalizeFirstLetter(data?.question)}
            </div>
          </div>
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Answer</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {(data && methodModel.capitalizeFirstLetter(data?.answer)) ||
                '--'}
            </div>
          </div>
         
        </div>
      </div>
    </Layout>
  );
};

export default Viewfaq;
